import { render, staticRenderFns } from "./LPopup.vue?vue&type=template&id=0b5b6f13"
import script from "./LPopup.vue?vue&type=script&lang=js"
export * from "./LPopup.vue?vue&type=script&lang=js"
import style0 from "./LPopup.vue?vue&type=style&index=0&id=0b5b6f13&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports